/* eslint-disable */
import dn from '@bingads-webui-component-legacy/humanize/decimal';
import $ from 'jquery';

export default {
  editBudget: function editBudget(fieldId, combinedBudget) {
    if (typeof combinedBudget == 'string') {
      combinedBudget = JSON.parse(combinedBudget.replace(/&quot;/g, '"'));
    }
    var editor = $.tmpl($('#budgetEditorTemplate'), {
      budgetValue: combinedBudget ? combinedBudget.BudgetAmount : '',
      budgetTypes: window.budgetTypes
    });
    if (combinedBudget) {
      $('.inline-budget-edit-type', editor).val(combinedBudget.SimplifiedBudgetLimitType);
    }
    return editor;
  },
  getBudget: function getBudget(control) {
    var budgetAmount = $(control).find('.inline-budget-edit-value').val();
    var budgetType = $(control).find('.inline-budget-edit-type').val();
    if (!(budgetAmount && budgetType)) {
      var currentValue = $(control).find('.combinedBudgetGridCellValue');
      budgetAmount = currentValue.data('budgetamount');
      budgetType = currentValue.data('budgettype');
    }
    return JSON.stringify({
      BudgetAmount: dn.fromLocalToStringStrict(budgetAmount),
      SimplifiedBudgetLimitType: budgetType
    });
  }
};

